import { useState, useEffect } from 'react';
import { relatoriosService } from '../../services';
import { formatCurrency } from '../../utils/format';
import './Relatorios.css';

export default function Relatorios() {
  const [tab, setTab] = useState('top');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    let promise;
    switch (tab) {
      case 'top': promise = relatoriosService.topProdutos(20); break;
      case 'pagamento': promise = relatoriosService.vendasFormaPagamento(); break;
      case 'colaborador': promise = relatoriosService.vendasColaborador(); break;
      case 'entregas': promise = relatoriosService.entregasEntregador(); break;
      case 'clientes': promise = relatoriosService.clientesFrequentes(); break;
      case 'categorias': promise = relatoriosService.categorias(); break;
      default: promise = relatoriosService.topProdutos(20);
    }
    promise.then(res => setData(res.data)).catch(() => setData([])).finally(() => setLoading(false));
  }, [tab]);

  return (
    <div className="relatorios-page">
      <h1 style={{marginBottom:16}}>📈 Relatórios</h1>

      <div className="rel-tabs">
        {[
          ['top', '🏆 Top Produtos'],
          ['pagamento', '💳 Formas de Pagamento'],
          ['colaborador', '👤 Colaboradores'],
          ['entregas', '🚴 Entregas'],
          ['clientes', '👥 Clientes Frequentes'],
          ['categorias', '📂 Categorias'],
        ].map(([k, label]) => (
          <button key={k} className={tab === k ? 'active' : ''} onClick={() => setTab(k)}>{label}</button>
        ))}
      </div>

      {loading ? <div className="loading"><div className="spinner"></div></div> : (
        <div className="table-container card">
          {tab === 'top' && (
            <table>
              <thead><tr><th>Produto</th><th>Qtd Vendida</th><th>Faturamento</th><th>Lucro</th></tr></thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={i}><td>{r.emoji} {r.nome}</td><td>{r.qtd_vendida}</td><td>{formatCurrency(r.faturamento)}</td><td style={{color:'var(--success)'}}>{formatCurrency(r.lucro)}</td></tr>
                ))}
              </tbody>
            </table>
          )}

          {tab === 'pagamento' && (
            <table>
              <thead><tr><th>Forma</th><th>Quantidade</th><th>Total</th><th>%</th></tr></thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={i}><td style={{textTransform:'capitalize'}}>{r.forma}</td><td>{r.qtd}</td><td>{formatCurrency(r.total)}</td><td>{r.percentual}%</td></tr>
                ))}
              </tbody>
            </table>
          )}

          {tab === 'colaborador' && (
            <table>
              <thead><tr><th>Colaborador</th><th>Pedidos</th><th>Produtos</th><th>Vendas</th><th>Comissão</th></tr></thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={i}><td>{r.nome}</td><td>{r.total_pedidos}</td><td>{r.total_produtos}</td><td>{formatCurrency(r.total_vendas)}</td><td style={{color:'var(--success)'}}>{formatCurrency(r.comissao)}</td></tr>
                ))}
              </tbody>
            </table>
          )}

          {tab === 'entregas' && (
            <table>
              <thead><tr><th>Entregador</th><th>Entregas</th><th>Tempo Médio</th><th>Total Taxas</th></tr></thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={i}><td>{r.nome}</td><td>{r.total_entregas}</td><td>{r.tempo_medio_min} min</td><td>{formatCurrency(r.total_taxas)}</td></tr>
                ))}
              </tbody>
            </table>
          )}

          {tab === 'clientes' && (
            <table>
              <thead><tr><th>Cliente</th><th>Telefone</th><th>Pedidos</th><th>Total Gasto</th></tr></thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={i}><td>{r.nome}</td><td>{r.telefone}</td><td>{r.qtd_pedidos}</td><td>{formatCurrency(r.total_gasto)}</td></tr>
                ))}
              </tbody>
            </table>
          )}

          {tab === 'categorias' && (
            <table>
              <thead><tr><th>Categoria</th><th>Quantidade</th><th>Faturamento</th></tr></thead>
              <tbody>
                {data.map((r, i) => (
                  <tr key={i}><td>{r.emoji} {r.categoria}</td><td>{r.qtd}</td><td>{formatCurrency(r.faturamento)}</td></tr>
                ))}
              </tbody>
            </table>
          )}

          {data.length === 0 && <p className="no-data" style={{padding:20}}>Sem dados para exibir</p>}
        </div>
      )}
    </div>
  );
}
